import React from 'react';
import { map, get } from 'lodash-es';
import Question from './Question';
import { listShape } from '../SummaryBlock.shape';

const customStyle = style => {
  const cardBackground = get(style, 'card.backgroundColor') && { backgroundColor: get(style, 'card.backgroundColor') };
  return { ...cardBackground };
};

const List = ({ id, title, questions, style }) => (
  <div style={customStyle(style)} className="grid-card" key={id}>
    <span className="title">{title}</span>
    {map(questions, item => (
      <Question
        key={get(item, 'id')}
        id={get(item, 'id')}
        question={get(item, 'question')}
        answer={get(item, 'answer')}
      />
    ))}
  </div>
);

List.propTypes = listShape;
List.defaultProps = {};

export default List;
